import getDealershipIdFromPathname from './getDealershipIdFromPathname';

export default function getOneTrustSiteId(pathname: string): string {
  return getDealershipIdFromPathname(pathname) ?? 'carvana';
}
